/** Stable FNV-1a derivation for a match epoch/revision pair. */
export function deriveBotSeed(matchId: string, revision: number): number {
  if (matchId.length === 0 || !Number.isSafeInteger(revision) || revision < 0) {
    throw new RangeError("A bot seed requires a non-empty match ID and non-negative revision.");
  }

  let hash = 0x811c_9dc5;
  const input = `${matchId}\u0000${revision}`;
  for (let index = 0; index < input.length; index += 1) {
    hash ^= input.charCodeAt(index);
    hash = Math.imul(hash, 0x0100_0193);
  }
  return hash >>> 0;
}
